import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-selection',
  templateUrl: './login-selection.component.html',
  styleUrls: ['./login-selection.component.scss']
})
export class LoginSelectionComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  redirectToLogin(business:any){
    sessionStorage.setItem('Business', business);
    this.router.navigate(['/auth/login']);
  }

  redirectToSignup(business:any){
    sessionStorage.setItem('Business', business);
    this.router.navigate(['/auth/signup']);
  }
}
